import React, { Component } from "react";
import InputRow from "./InputRow";
import { handleAlphabetCheck, handleNumberCheck } from "../constants";
import PropTypes from "prop-types";
export default class Parent4 extends Component {
  render() {
    return (
      <div>
        <div>
          <InputRow
            name="select"
            data={this.props.relationshipData}
            required={this.props.deceased ? "" : ""}
            errMsg={this.props.errRelation}
            value={this.props.relationship}
            onChange={(e) => this.props.relationshipUpdate(e)}
            rowName="Relationship to You"
            disabled={this.props.disabled}
            hover="Tell us how the person is related to you."
          />
          {/* <InputRow
            name="select"
            data={this.props.prefixData}
            value={this.props.selectedPrefix}
            onChange={this.props.onChangePrefix}
            rowName="Prefix"
            required={this.props.deceased ? "" : "*"}
            errMsg={this.props.errPrefix}
            disabled={this.props.disableAll}
          /> */}
          <InputRow
            name="text"
            rowName="First Name"
            required={this.props.deceased ? "" : ""}
            errMsg={this.props.errFName}
            value={this.props.fName}
            onChange={(e) => {
              if (handleAlphabetCheck(e) === 1 || e === "") {
                this.props.onChangeFName(e);
              } else {
                alert("Please Enter Alphabets only!");
              }
            }}
            disabled={this.props.disableAll}
            //hover="Enter the name of one of the following: your mother, your father or your legal guardian. أدخل اسم أحد الإجراءات التالية: أمك أو والدك أو الوصي القانوني. "
          />
          {/* <InputRow
            name="text"
            rowName="Middle Name"
            required={this.props.deceased ? "" : "*"}
            errMsg={this.props.errMName}
            value={this.props.mName}
            onChange={(e) => {
              if (handleAlphabetCheck(e) === 1 || e === "") {
                this.props.onChangeMName(e);
              } else {
                alert("Please Enter Alphabets only!");
              }
            }}
            disabled={this.props.disableAll}
          /> */}
          <InputRow
            name="text"
            rowName="Last Name"
            required={this.props.deceased ? "" : ""}
            errMsg={this.props.errLName}
            value={this.props.lName}
            onChange={(e) => {
              if (handleAlphabetCheck(e) === 1 || e === "") {
                this.props.onChangeLName(e);
              } else {
                alert("Please Enter Alphabets only!");
              }
            }}
            disabled={this.props.disableAll}
          />

          <InputRow
            name="text"
            rowName="Mobile Number"
            required={""}
            errMsg={this.props.errMobile}
            value={this.props.mobileNumber}
            onChange={(e) => {
              if (handleNumberCheck(e) === 0) {
                this.props.onChangeNumber(e);
              } else {
                alert("Enter Numbers only!");
              }
            }}
            disabled={this.props.disableAll}
            // hover={
            //   this.props.guardian
            //     ? "Insert the contact number of your guardian."
            //     : "Insert the contact number of your parent."
            // }
            // hover="Insert the contact number of your parent. رقم الاتصال لوالدك."
          />
          <InputRow
            name="email"
            rowName="E-mail Address"
            required="" // 4 is the father Id
            value={this.props.email}
            onChange={(val) => this.props.onChangeEmail(val)}
            errMsg={this.props.errEmail}
            //disabled={this.props.disableAll}
            // hover={
            //   this.props.guardian
            //     ? "Insert the email address of your guardian."
            //     : "Insert the email address of your parent."
            // }
            //hover="Insert the email address of your parent . عنوان البريد الإلكتروني لوالديك."
          />

          <InputRow
            rowName="Status"
            name="select"
            value={this.props.status}
            data={[
              { Id: "Working", value: "Working" },
              { Id: "Graduated", value: "Graduated" },
              { Id: "Studying", value: "Studying" },
            ]}
            required=""
            errMsg={this.props.errSuffix}
            onChange={(val) => this.props.onChangeSuffix(val)}
          />

          {/* {this.props.relationshipData[0].value === "Father" ||
          this.props.relationshipData[0].value === "Mother" ? (
            <>
              {this.props.isTKHEmployee == true ? (
                <InputRow
                  name="text"
                  rowName="Id"
                  //  value= {illness}
                  value={
                    !this.props.isTKHEmployee ||
                    this.props.isTKHEmployee == "False"
                      ? ""
                      : this.props.idnumber
                  }
                  disabled={
                    !this.props.isTKHEmployee ||
                    this.props.isTKHEmployee == "False"
                      ? true
                      : false
                  }
                  onChange={(val) => this.props.onChangeIdNumber(val)}
                  required={this.props.isTKHEmployee ? "*" : null}
                  errMsg={this.props.errIdNumber}
                />
              ) : null}
            </>
          ) : null} */}
        </div>
      </div>
    );
  }
}
Parent4.propTypes = {
  relationshipData: PropTypes.array.isRequired,
  relationship: PropTypes.number.isRequired,
  relationshipUpdate: PropTypes.func,
  disabled: PropTypes.bool,
  disableAll: PropTypes.bool,
  prefixData: PropTypes.array.isRequired,
  selectedPrefix: PropTypes.number.isRequired,
  onChangeEmail: PropTypes.func.isRequired,
  onChangeFName: PropTypes.func.isRequired,
  onChangeLName: PropTypes.func.isRequired,
  onChangeNumber: PropTypes.func.isRequired,
  onChangePrefix: PropTypes.func.isRequired,
  fName: PropTypes.string.isRequired,
  lName: PropTypes.string.isRequired,
  mobileNumber: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
  errEmail: PropTypes.string,
  errRelation: PropTypes.string,
  errPrefix: PropTypes.string,
  errFName: PropTypes.string,
  errMName: PropTypes.string,
  errLName: PropTypes.string,
  errProfession: PropTypes.string,
  errMobile: PropTypes.string,
  errIdNumber: PropTypes.string,
  deceased: PropTypes.bool,
  deceasedOption: PropTypes.bool,
  deceasedChange: PropTypes.func,
  emailRequired: PropTypes.bool,
  guardian: PropTypes.bool,
  idnumber: PropTypes.string,
};
